import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { TransactionRequestService } from 'src/app/services/transaction-request/transaction-request.service';

/** Dialog data provided to Cancel Request Dialog */
export interface CancelRequestDialogData {
  requestId: string;
}

/**
 * CancelRequestDialogComponent displays a confirmation dialog for canceling
 * a transaction request, providing user confirmation before proceeding.
 */
@Component({
    selector: 'app-cancel-request-dialog',
    templateUrl: './cancel-request-dialog.component.html',
    styleUrl: './cancel-request-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CancelRequestDialogComponent {
  /** Dependency injections */
  private readonly _dialogRef: MatDialogRef<CancelRequestDialogComponent> = inject(MatDialogRef);
  private readonly _transactionRequestService: TransactionRequestService = inject(TransactionRequestService);
  private readonly _toastrService: ToastrService = inject(ToastrService);

  /** Dialog data */
  public data: CancelRequestDialogData = inject(MAT_DIALOG_DATA);

  /** Component state */
  public isSubmitting = false;

  /**
   * Handle the cancel request action
   */
  public onYesClick(): void {
    this.isSubmitting = true;

    this._transactionRequestService.cancelRequest$(this.data.requestId)
      .pipe(finalize(() => setTimeout(() => this.isSubmitting = false, 1000)))
      .subscribe({
        next: () => {
          this._toastrService.success('Request cancelled successfully');
          this._dialogRef.close(true);
        },
        error: (err: any) => {
          console.error('[CANCEL-REQUEST-DIALOG-COMPONENT]: Error cancelling request:', err);
          this._toastrService.error('Failed to cancel request');
          this.isSubmitting = false;
        }
      });
  }

  /**
   * Handle the go back action
   */
  public onNoClick(): void {
    this._dialogRef.close(false);
  }

  /**
   * Handle the close dialog action
   */
  public onCloseClick(): void {
    this._dialogRef.close();
  }
}
